var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "M9.5 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7h-6c-5 0-7 2-7 7v6c0 5 2 7 7 7Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "m8.25 12 2.83 2.83 5.67-5.66"
})));
export { SvgCheckbox as ReactComponent };
export default __webpack_public_path__ + "092a3ac6cfdb748551cae0654f327663.svg";